module.exports = __webpack_public_path__ + "img/Frame-61.7d140178.svg";